import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "form-header" }
const _hoisted_3 = { class: "title-3" }
const _hoisted_4 = { class: "form-content flex-grow" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "small mt-1" }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "form-footer" }
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = ["disabled", "loading-key"]

import FileUploader from "@/domains/app/components/FileUploader.vue";
import { ref } from "vue";
import { UploadedFile } from "@/domains/app/forms";
import { useLoading } from "@/domains/app/loading";
import { request } from "@/domains/api/api";
import { useUser } from "@/domains/auth/user";
import { ROLE_ADMIN, ROLE_DELEGATE } from "@/domains/cruds/users/users";


export default /*#__PURE__*/_defineComponent({
  props: {
    resourceKey: null,
    resourceName: null,
    excelDescription: null,
    importUrl: null,
    canImportForDep: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    resourceKey: string;
    resourceName: string;
    excelDescription: string;
    importUrl: string;
    canImportForDep?: boolean;
}



const fileToImport = ref<UploadedFile>();
const error = ref<string>();
const totalImported = ref<number>();
const forDep = ref<boolean>(false);

const { user } = useUser();

function submit() {
    error.value = "";
    if (!fileToImport.value || !fileToImport.value.filename) return;

    const setLoading = useLoading(
        "import-resource-" + props.resourceKey
    ).setLoading;
    setLoading(true);

    request<{ total: number }>(
        props.importUrl,
        "post",
        (err) => (error.value = err.message ?? "Une erreur est survenue"),
        {
            file: fileToImport.value.filePath,
            department_id: forDep.value
                ? user?.value?.department_id ?? null
                : null,
        }
    )
        .then((data) => {
            totalImported.value = data?.total;
        })
        .catch(() => {
            error.value = "Une erreur est survenue";
        })
        .finally(() => {
            setLoading(false);
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, "Importer des " + _toDisplayString(__props.resourceName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", {
          for: __props.resourceKey + '-import-file-input'
        }, "Fichier excel", 8, _hoisted_6),
        _createVNode(FileUploader, {
          id: __props.resourceKey + '-import-file-input',
          file: fileToImport.value,
          "onUpdate:file": _cache[0] || (_cache[0] = ($event: any) => ((fileToImport).value = $event)),
          title: "Fichier",
          accept: ".xlsx"
        }, null, 8, ["id", "file"]),
        _createElementVNode("span", _hoisted_7, " Format du fichier Excel: " + _toDisplayString(__props.excelDescription), 1)
      ]),
      (
                    __props.canImportForDep !== false &&
                    (_unref(user)?.roles.includes(_unref(ROLE_DELEGATE)) ||
                        _unref(user)?.roles.includes(_unref(ROLE_ADMIN)))
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("label", {
              for: __props.resourceKey + '-dep'
            }, "Ajouter à la liste du département", 8, _hoisted_9),
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: __props.resourceKey + '-dep',
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((forDep).value = $event))
            }, null, 8, _hoisted_10), [
              [_vModelCheckbox, forDep.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      (totalImported.value !== undefined)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: _normalizeClass({
                    'text-warning': totalImported.value === 0,
                    'text-success': totalImported.value > 0,
                })
          }, _toDisplayString(totalImported.value) + " importés ", 3))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        class: "btn btn-primary",
        disabled: !fileToImport.value,
        "loading-key": 'import-resource-' + __props.resourceKey
      }, " Importer ", 8, _hoisted_13)
    ])
  ], 40, _hoisted_1))
}
}

})